import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { AuthorizedContent } from '@frontegg/react';
import React from 'react';
import { useDashboardMode } from '../../../contexts/dashboardModeContext';
import RolesType from '../../../utils/enum/RolesType';
import { Indicator } from '../dashboardInterfaces';
import { DragAndDropIconStyled } from '../styled';
import IndicatorCard from './indicatorCard';

interface SortableIndicatorCardProps extends React.ComponentProps<typeof IndicatorCard> {
    indicator: Indicator;
    isDraggable?: boolean;
    isDragging?: boolean;
    surveyName?: string;
    dashboardName?: string;
}

const SortableIndicatorCard: React.FC<SortableIndicatorCardProps> = (props) => {
    const { indicator, isDragging, isDraggable, surveyName, dashboardName } = props;
    const { attributes, listeners, setNodeRef, transform } = useSortable({ id: indicator.id });
    const { isCreationMode } = useDashboardMode();

    const style = {
        opacity: 1,
        background: 'transparent',
        transform: CSS.Translate.toString(transform),
        zIndex: isDragging ? 100 : 0,
        position: 'relative' as const,
    };

    const dragHandle = isDraggable && isCreationMode
        ? <AuthorizedContent requiredRoles={[RolesType.ADMIN, RolesType.ADMIN_MOAI]}><DragAndDropIconStyled {...attributes} {...listeners} /></AuthorizedContent>
        : null;

    return (
        <div ref={setNodeRef} className='relative w-full' style={style}>
            <IndicatorCard {...props} dashboardName={dashboardName} dragHandle={dragHandle} surveyName={surveyName} />
        </div>
    );
};

export default SortableIndicatorCard;
